import { useState, useEffect, useRef } from "react";
import {
    Card,
    Col,
    Row,Button,Table,Menu
} from "antd";
import { SearchOutlined } from '@ant-design/icons';
import { Input, Space } from 'antd';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { all_data, deleteRecord } from "../store/action/sections";
import Highlighter from 'react-highlight-words'
import StyleDropdown from "../components/forms/dropdown";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import RenderHtml from "../components/renderHtml";
import { message } from "antd";
import { domain } from "../api";
// table code start

 
  function Sections() {
    const dispatch = useDispatch()
    const Navigate = useNavigate()
    const {id} = useParams();
    const sections = useSelector(state => state.sections.data, shallowEqual) || []

      // table filter
      const [searchText, setSearchText] = useState('');
      const [searchedColumn, setSearchedColumn] = useState('');
      const [commentDesc, setCommentDesc] = useState(null);
      const searchInput = useRef(null);
      const handleSearch = (selectedKeys, confirm, dataIndex) => {
          confirm();
          setSearchText(selectedKeys[0]);
          setSearchedColumn(dataIndex);
      };
      const handleReset = (clearFilters) => {
          clearFilters();
          setSearchText('');
      };
      const getColumnSearchProps = (dataIndex) => ({
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
              <div
                  style={{
                      padding: 8,
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
              >
                  <Input
                      ref={searchInput}
                      placeholder={`Search ${dataIndex}`}
                      value={selectedKeys[0]}
                      onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                      onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                      style={{
                          marginBottom: 8,
                          display: 'block',
                      }}
                  />
                  <Space>
                      <Button
                          type="primary"
                          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                          icon={<SearchOutlined />}
                          size="small"
                          style={{
                              width: 90,
                          }}
                      >
                          Search
                      </Button>
                      <Button
                          onClick={() => clearFilters && handleReset(clearFilters)}
                          size="small"
                          style={{
                              width: 90,
                          }}
                      >
                          Reset
                      </Button>
                  </Space>
              </div>
          ),
          filterIcon: (filtered) => (
              <SearchOutlined
                  style={{
                      color: filtered ? '#0a2471' : undefined,
                  }}
              />
          ),
          onFilter: (value, record) =>
              record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownOpenChange: (visible) => {
              if (visible) {
                  setTimeout(() => searchInput.current?.select(), 100);
              }
          },
          render: (text) =>
              searchedColumn === dataIndex ? (
                  <Highlighter
                      highlightStyle={{
                          backgroundColor: '#ffc069',
                          padding: 0,
                      }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={text ? text.toString() : ''}
                  />
              ) : (
                  text
              ),
      });
      // table filter

    useEffect(()=>{
      dispatch(all_data(id))
    },[dispatch])
    
    const deleteOrder = (id) =>{
        var confirmed = window.confirm("Are you sure you want to proceed?");
        if (confirmed) {
          deleteRecord(id).then(res =>{
            if(res.status){
              dispatch(all_data())
              message.success("Successfully deleted")
            }
          })
          .catch(e => message.error("Failed to delete"))
          } 
    }



    const columns = [
      {
        title: "Poster",
        key: "poster",
        dataIndex: "poster",
        render : (value, row) => (
          value && <div><img src={domain + value} alt="poster image" className="table-image" /></div>
        )
      },
      {
        title: "Lesson",
        key: "lesson",
        dataIndex: "lesson",
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        ...getColumnSearchProps('title')
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        render : (value, row) => (
          value && <RenderHtml htmlContent={value} />
        )
      },     
      {
        title: 'Actions',
        dataIndex: 'id',
        fixed: 'right',
        width: 150,
        render: (value, val) => {
              let menu = (
                    <Menu>
                        <Menu.Item onClick={()=> Navigate(`/editSection/${value}`)}>View Section</Menu.Item>
                        <Menu.Item onClick={()=> deleteOrder(value)}>Delete Section</Menu.Item>
                    </Menu>
              )
            return (
                <StyleDropdown menu={menu} />
            )
        }
    },
    ];

    const downloadExcelFile = () =>{
      let excelSheet = [];
      if(sections?.length === 0){
        message.warning("No Registrations to download")
        return true
      }
      console.log("sections")
      // sections?.map((val,key)=>{
      //   excelSheet.push({
      //     'S.NO' : key + 1,
      //     "Name": val.name,
      //     "Phone": val.phone,
      //     "Email": val.email,
      //     "Institute": val.institute,
      //     "Qualification": val.qualification,
      //     "Selected Program": val.selected_program,
      //     "LLB First Year": val.llb_first_year,
      //     "LLB Second Year": val.llb_second_year,
      //     "LLB Third Year": val.llb_third_year,
      //     "IP": val.ip,
      //     "Time": new Date(val.time).toLocaleString()
      //   })
      // })
      // exportToExcel(excelSheet, `registration_${Math.random()}`)
    }

    return (
      <>
   
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs="24" xl={24}>
              <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                title={(<div className="style-row w-100"><h4 className="text-center">Sections</h4> <div>
                  <Button type="primary" onClick={downloadExcelFile} className="style-btn d-none">Download Excel File</Button>
                  <Button type="primary" onClick={()=> Navigate(`/addIntoLesson/${id}`)} className="style-b">Add Section</Button>
                  </div></div>)}
              >
                <div className="table-responsive">
                  {sections && sections.length > 0 &&
                  <Table
                    columns={columns}
                    dataSource={sections}
                    pagination={false}
                    className="ant-border-space"
                  />
                  }
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
  
  export default Sections;
  